
import { Link, useNavigate } from "react-router-dom";


export default function VehicleMaintenancesTable() {
    const navigate = useNavigate();

    const handleNavigate = (buscode) => {
        navigate(`/${buscode}`);


    };
    const data = [
        { id: 1, buscode: "MH20ER4534", maintenancetask: "Servicing", scheduleduration: "4", startdate: "Fri Aug 30 2024", nextdate: "Mon May 12 2024", typeoftask: "Instant" },
        { id: 2, buscode: "MH02MN0098", maintenancetask: "Servicing", scheduleduration: "4", startdate: "Fri Aug 30 2024", nextdate: "Mon May 12 2024", typeoftask: "Instant" },
        { id: 3, buscode: "MH03AS3945", maintenancetask: "Servicing", scheduleduration: "24", startdate: "Fri Aug 30 2024", nextdate: "Mon May 12 2024", typeoftask: "Instant" },
        { id: 4, buscode: "MH04KL0921", maintenancetask: "Servicing", scheduleduration: "45", startdate: "Fri Aug 30 2024", nextdate: "Mon May 12 2025", typeoftask: "Instant" },
        { id: 5, buscode: "MH05MH5932", maintenancetask: "Servicing", scheduleduration: "44", startdate: "Thu Dec 23 1974", nextdate: "Mon May 12 2025", typeoftask: "Instant" },
        { id: 6, buscode: "MH06MJ4321", maintenancetask: "Servicing", scheduleduration: "4", startdate: "Mon Jan 11 2022 ", nextdate: "Mon May 12 2025", typeoftask: "Instant" },
        { id: 7, buscode: "MH07ND4567", maintenancetask: "Servicing", scheduleduration: "5", startdate: "Wed Mar 30 2022", nextdate: "Mon May 12 2025", typeoftask: "Instant" },
        { id: 8, buscode: "MH08KK4909", maintenancetask: "Servicing", scheduleduration: "3", startdate: "Wed Mar 23 2022", nextdate: "Mon May 12 2025", typeoftask: "Scheduled" },
        { id: 9, buscode: "MH11KL0008", maintenancetask: "Servicing", scheduleduration: "11", startdate: "Sat Jun 20 2022", nextdate: "Mon May 12 2025", typeoftask: "Scheduled" },
        { id: 10, buscode: "MH20UI3424", maintenancetask: "Servicing", scheduleduration: "12", startdate: "Mon Jun 22 2022", nextdate: "Mon May 12 2025", typeoftask: "Instant" },
        { id: 11, buscode: "MH20SQ9021", maintenancetask: "HGD", scheduleduration: "34", startdate: "Tue Jun 23 2022 ", nextdate: "Mon May 12 2025", typeoftask: "Scheduled" },
        { id: 12, buscode: "MH23MK8245", maintenancetask: "Cluch Wire", scheduleduration: "13", startdate: "Tue Jun 23 2022", nextdate: "Mon May 12 2025", typeoftask: "Instant" },
        { id: 13, buscode: "MH24NF5321", maintenancetask: "Break Linear", scheduleduration: "55", startdate: "Tue Jun 23 2022", nextdate: "Mon May 12 2025", typeoftask: "Scheduled" },
        { id: 14, buscode: "MH22PQ4441", maintenancetask: "Engine Oil", scheduleduration: "12", startdate: "Tue Jun 23 2022", nextdate: "Mon May 12 2025", typeoftask: "Instant" },
        { id: 15, buscode: "MH12EE2323", maintenancetask: "Battery", scheduleduration: "34", startdate: "Thu Jan 1 1970", nextdate: "Mon May 12 2025", typeoftask: "Instant" },
        { id: 30, buscode: "MH11FG9090", maintenancetask: "Oil Seal", scheduleduration: "6", startdate: "Fri Aug 30 2024", nextdate: "Mon May 12 2025", typeoftask: "Scheduled" },
        { id: 17, buscode: "MH20UI1221", maintenancetask: "Speed Meter", scheduleduration: "9", startdate: "Fri Aug 30 2024", nextdate: "Mon May 12 2025", typeoftask: "Instant" },
        { id: 18, buscode: "MH20EE0890", maintenancetask: "Tyer", scheduleduration: "22", startdate: "Fri Aug 30 2024", nextdate: "Mon May 12 2025", typeoftask: "Scheduled" },
        { id: 19, buscode: "MH20SQ0987", maintenancetask: "Servicing", scheduleduration: "21", startdate: "Wed Mar 30 2022", nextdate: "Mon May 12 2025", typeoftask: "Instant" },
        { id: 20, buscode: "MH21XQ0087", maintenancetask: "Servicing", scheduleduration: "21", startdate: "Wed Mar 30 2022", nextdate: "Mon May 12 2025", typeoftask: "Instant" },


    ];


    return (
        <div className="vehicle-maintenance-container my-4">

            <div className="special-header panel-white-all bg-white d-flex justify-content-between align-items-center ">
                <h4 className="mb-0 page-title">Vehicle Maintenances</h4>
                <div className="d-flex align-items-center gap-2">
                    <Link to="/accountant/createvehiclemaintenance" type="button" className="btn custom-btn">Create Vehicle Maintenance</Link>

                    <div className="dropdown">
                        <button id="btnGroupDropExport" type="button" className="btn custom-btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                            Export
                        </button>
                        <ul className="dropdown-menu" aria-labelledby="btnGroupDropExport">
                            <li><a className="dropdown-item" href="#">Save as PDF</a></li>
                            <li><a className="dropdown-item" href="#">Save as PNG</a></li>
                            <li><a className="dropdown-item" href="#">Save as CSV</a></li>
                            <li><a className="dropdown-item" href="#">Save as TXT</a></li>
                            <li><a className="dropdown-item" href="#">Save as XML</a></li>
                            <li><a className="dropdown-item" href="#">Save as SQL</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="table-top-filters d-flex flex-wrap gap-3">
                
                    <select className="form-select form-control-sm dropdrown-iteam" style={{ maxWidth: "200px" }}>
                        <option className="vehicle-dropdown">Bus Number</option>
                        <option className="vehicle-dropdown">MH20EE3948</option>
                        <option className="vehicle-dropdown">MH21RE4890</option>
                    </select>
                
                    <input type="text" className="form-control form-control-sm" placeholder="Maintenance Task" style={{ maxWidth: "200px" }} />
                
         <button type="button" class="btn custom-btn">Clear</button>

            </div>


            <div className="card-body">

                <div className="table-responsive">
                    <table className="custom-table" style={{ marginTop: '1px' }}>
                        <thead>


                            <tr>
                                <th style={{textAlign:'center'}}>Sr No</th>
                                <th style={{textAlign:'center'}}>Bus Code</th>
                                <th style={{textAlign:'center'}}>Maintenance Task</th>
                                <th style={{textAlign:'center'}}>Schedule Duration(H)</th>
                                <th style={{textAlign:'center'}}>Start Date</th>
                                <th style={{textAlign:'center'}}>Next Due Date</th>
                                <th style={{textAlign:'center'}}>Type of Task/Mileege</th>
                                <th >Action</th>
                            </tr>

                        </thead>
                        <tbody>
                            {data.map((row) => (
                                <tr key={row.id}>
                                    <td style={{textAlign:'center'}}>{row.id}</td>
                                    <td style={{textAlign:'center'}}>{row.buscode}</td>
                                    <td style={{textAlign:'center'}}>{row.maintenancetask}</td>
                                    <td style={{textAlign:'center'}}>{row.scheduleduration}</td>
                                    <td style={{textAlign:'center'}}>{row.startdate}</td>
                                    <td style={{textAlign:'center'}}>{row.nextdate}</td>
                                    <td style={{textAlign:'center'}}>{row.typeoftask}</td>
                                    <td style={{textAlign:'center'}}>
                                        <div className="btn-group">
                                            <button
                                                type="button"
                                                className="btn  btn-sm"
                                                onClick={() => handleNavigate(row.buscode)}
                                                title="View">
                                                <i class="bi bi-eye"></i>
                                            </button>
                                            <Link to="/accountant/updatevehiclemaintenance"
                                                type="button"
                                                className="btn  btn-sm"
                                                title="View">
                                                <i className="bi bi-pencil-square"></i>
                                            </Link>
                                            <button
                                                type="button"
                                                className="btn  btn-sm"
                                                onClick={() => handleNavigate(row.buscode)}
                                                title="View">
                                                <i className="bi bi-trash3"></i>
                                            </button>
                                        </div>

                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>




    );
}
